<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
#page-live-visitor .ag-header-cell,
#page-live-visitor .ag-cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.live-data tr:first-child {
  background-color: yellow;
}
.live-data .ag-row-first {
  background-color: yellow;
}

/*Debashis*/
@keyframes blinking {
  0% {
    background-color: #fffef0;
    /*border: 0px solid #871924;*/
  }
  /* YOU CAN ADD MORE COLORS IN THE KEYFRAMES IF YOU WANT
            50%{
              background-color: #55d66b;
              border: 5px solid #126620;
            }
            */
  100% {
    background-color: #e2efd4;
    /*border: 0px solid #6565f2;*/
  }
}

/*#demo {
                width: 300px;
                height: 300px;
                background-color: #222291;
                border: 5px solid #6565f2;
            }*/

.live-data .ag-row-first {
  /* NAME | TIME | ITERATION */
  background-color: #e2efd4;
  animation: blinking 5s infinite;
}
.header-custome span {
  font-size: 15px;
}
</style>
<template>
  <div id="page-live-visitor">
    <div class="header-custome">
      <h2>
        Live Visitors<span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h2>
      <div class="knowlg-base-wrap-sec">
        <a
          href="/pages/knowledge-base/category-analytics/question-1"
          target="blank"
          ><span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line></svg
          ></span>
          Need help with this section?</a
        >
      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span v-if="pageView_UserData_duplicate.length == 0" class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  pageView_UserData.length - currentPage * paginationPageSize >
                  0
                    ? currentPage * paginationPageSize
                    : pageView_UserData.length
                }}
                of {{ pageView_UserData.length }}</span
              >

              <span v-else class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  pageView_UserData_duplicate.length -
                    currentPage * paginationPageSize >
                  0
                    ? currentPage * paginationPageSize
                    : pageView_UserData_duplicate.length
                }}
                of {{ pageView_UserData_duplicate.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>-->
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <span
            v-show="showUpdatedTxt"
            style="background: #d8d6d6; margin-left: 10px"
            ><b>Last Updated :</b> 10 Seconds Ago!!</span
          >
        </div>
        <!--ADD Attendee-->

        <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
          Subject:
          <h3>{{ welcomeMailSubject }}</h3>
          <br />
          <div v-html="welcomeMailText"></div>
          <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
          <br />
          <div click="sendbtn-section">
            <vs-button color="rgb(76, 139, 246)" type="filled"@click="popupActiveMail = false"
              >Cancel</vs-button
            >
            <!--<vs-button class="mail-btn" type="gradient" @click="sendMail">Send Mail</vs-button>-->
          </div>
        </vs-popup>
        <div
          class="vx-col mr-5"
          style="text-align: center"
          v-if="pageView_UserData_duplicate.length == 0"
        >
          <label><b>Total:&nbsp;</b></label>
          <label>{{ pageView_UserData.length }}</label>
        </div>
        <div class="vx-col mr-5" style="text-align: center" v-else>
          <label><b>Total:&nbsp;</b></label>
          <label>{{ pageView_UserData_duplicate.length }}</label>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-42"
          >
            <span class="mr-2 leading-none" v-if="filtrDay == 0"
              ><small>Filter : 24 hours</small></span
            >
            <span class="mr-2 leading-none" v-else-if="filtrDay > 0"
              ><small>Filter : {{ filtrDay }} days</small></span
            >
            <span class="mr-2 leading-none" v-else-if="filtrHours > 0"
              ><small>Filter : {{ filtrHours }} hours</small></span
            >
            <span class="mr-2 leading-none" v-else-if="filtrDay == -1"
              ><small>Filter : All</small></span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeFilterByDays(6)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>6 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(12)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>12 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(24)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>24 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(48)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>48 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(3)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Last 3 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(7)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Last 7 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(-1)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>All</span>
              </span>
            </vs-dropdown-item>

            <!--<vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Set Inactive</span>
              </span>
            </vs-dropdown-item>-->
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon
                  icon="FileIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="container">
        <div class="my-5">
          <div v-show="chart != null">
            <canvas id="myChart" height="50px"></canvas>
          </div>
        </div>
      </div>
      <!-- AgGrid Table -->
      <div
        v-bind:class="livedata"
        v-if="pageView_UserData_duplicate.length == 0"
      >
        <ag-grid-vue
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-full my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="pageView_UserData"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @selection-changed="onSelectionChanged"
        ></ag-grid-vue>

        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      </div>
      <div v-bind:class="livedata" v-else>
        <ag-grid-vue
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-full my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="pageView_UserData_duplicate"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          @selection-changed="onSelectionChanged"
        ></ag-grid-vue>

        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import parser from "ua-parser-js";
import moment from "moment-timezone";

// Store Module
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/UserLoginCellRendererActions.vue";
import CellRendererIPAddressAction from "./cell-renderer/CellRendererIPAddressAction.vue";
import Chart from "chart.js";

//console.log(db);
//const event_collectionName = 'sayek-dev';
var Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
let firstVisit = true;
var vm;
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

let setLiveVisitorWatch;
let counter = 0;
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererIPAddressAction,
  },
  data() {
    return {
      filterModel: -1,
      filtrDay: null,
      filtrHours: null,
      gridSelectedRows: 0,
      livedata: "",
      settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      showUpdatedTxt: false,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      pageView_UserData: [],
      pageView_UserData_duplicate: [],
      userDataForGraph: [],
      chart: null,
      loginDates: [],
      loginUserCount: [],
      columnDefs: [
        //{
        //  //headerName: 'ID',
        //  field: "AttendeeId",
        //  //width: 40,
        //  filter: false,
        //  checkboxSelection: true,
        //  headerCheckboxSelectionFilteredOnly: true,
        //  headerCheckboxSelection: true
        //},
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "First Name",
          field: "Fname",
          filter: true,
          width: 200,
        },
        {
          headerName: "Last Name",
          field: "Lname",
          filter: true,
          width: 200,
        },
        {
          headerName: "Email",
          field: "UserEmail",
          filter: true,
          width: 200,
        },
        {
          headerName: "Page URL",
          field: "page",
          filter: true,
          width: 200,
        },
        // {
        //   headerName: "Type",
        //   field: "Action",
        //   filter: true,
        //   width: 100
        // },
        {
          headerName: "Action",
          field: "ActionLabel",
          filter: true,
          width: 150,
        },
        {
          headerName: "Date & Time",
          field: "ActionTimeStr",
          filter: true,
          width: 250,
        },
        {
          headerName: "Device Info",
          field: "DeviceInfo",
          filter: true,
          width: 400,
        },
        {
          headerName: "City",
          field: "city",
          filter: true,
          width: 350,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererIPAddressAction,
      },
    };
  },
  computed: {
    //pageViewUserData() {
    //  return vm.pageView_UserData;
    //},
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];
        var timeZone = [];

        timeZone.push("Report Exported In ");
        var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
        timeZone.push('"' + timezone + " Time Zone" + '"');
        datarow.push("First Name");
        datarow.push("Last Name");
        datarow.push("Email");
        datarow.push("Page URL");
        //datarow.push("Type");
        datarow.push("Action");
        datarow.push("Date & Time");
        datarow.push("Device Info");
        datarow.push("User Agent");
        datarow.push("IP Address");
        datarow.push("City");
        var engagementData = [];
        engagementData.push(datarow);
        var TimeZoneHeader = [];
        TimeZoneHeader.push(timeZone);

        selectedRows.map((row) => {
          //--------------------------------------------------------
          datarow = [];

          var fname = row.Fname == undefined ? "" : row.Fname;
          datarow.push('"' + fname + '"');
          var lname = row.Lname == undefined ? "" : row.Lname;
          datarow.push('"' + lname + '"');
          var email = row.UserEmail == undefined ? "" : row.UserEmail;
          datarow.push('"' + email + '"');
          var pageUrl = row.page == undefined ? "" : row.page;
          datarow.push('"' + pageUrl + '"');
          // var type = row.Action == undefined ? "" : row.Action;
          // datarow.push(type);
          var action = row.ActionLabel == undefined ? "" : row.ActionLabel;
          datarow.push('"' + action + '"');
          var dateTime =
            row.ActionTimeStr == undefined ? "" : row.ActionTimeStr;
          datarow.push('"' + dateTime + '"');
          var deviceInfo = row.DeviceInfo == undefined ? "" : row.DeviceInfo;
          datarow.push('"' + deviceInfo + '"');
          var userAgent = row.UserAgent == undefined ? "" : row.UserAgent;
          datarow.push('"' + userAgent + '"');
          var ipAddress = row.userIp == undefined ? "" : row.userIp;
          datarow.push('"' + ipAddress + '"');
          var city = row.city == undefined ? "" : row.city;
          datarow.push('"' + city + '"');
          engagementData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        TimeZoneHeader.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        engagementData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "LiveVisitorData_" + "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one live visitors data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    getDataForGraph: function () {
      this.loginDates = [];
      this.loginUserCount = [];
      var names = [];
      var loginData = this.userDataForGraph ? this.userDataForGraph : [];
      var date;
      var counter = 1;
      loginData.forEach((doc) => {
        date = doc.ActionTimeStr;
        this.loginDates.push(date);
        this.loginUserCount.push(counter);
        names.push(doc.Uname);
        counter++;
      });

      if (this.chart != null) {
        this.chart.destroy();
      }
      var ctx = document.getElementById("myChart");
      this.chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.loginDates,
          datasets: [
            {
              label: "User",
              backgroundColor: "#4c8af6",
              borderColor: "#4c8af6",
              fill: false,
              data: this.loginUserCount.reverse(),
            },
          ],
        },
        options: {
          legend: {
            display: false,
          },
          title: {
            display: false,
            text: "Real Time Login",
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || "";

                if (label) {
                  label += ": ";
                }

                label += names[tooltipItem.index];
                return label;
              },
            },
          },
          scales: {
            xAxes: [
              {
                type: "time",
                time: {
                  unit: "days",
                  displayFormats: {
                    days: "M/DD",
                  },
                  tooltipFormat: "MM-DD hh:mm:ss A",
                },
                scaleLabel: {
                  display: true,
                  labelString: "Date/Time",
                },
              },
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "No. of Logins",
                },
                ticks: {
                  callback: function (value, index, values) {
                    return value;
                  },
                },
              },
            ],
          },
        },
      });
    },
    changeFilterByDays(days) {
      // this.$vs.loading();
      this.filterModel = days;
      var currentDate = new Date();
      if (days == 6 || days == 12 || days == 24 || days == 48) {
        currentDate.setHours(currentDate.getHours() - days);
        this.filtrHours = days;
        this.filtrDay = null;
      } else if (days == -1) {
        currentDate = null;
        this.filtrDay = -1;
      } else {
        currentDate.setDate(currentDate.getDate() - days);
        this.filtrDay = days;
        this.filtrHours = null;
      }
      this.$store
        .dispatch("analytics/fetchLiveVisitorwData", days)
        .then((res) => {
          this.pageView_UserData = res.data;
          this.userDataForGraph = this.pageView_UserData;
          this.showUpdatedTxt = true;
          this.getDataForGraph();
          // this.$vs.loading.close();
        })
        .catch((err) => {
          //this.$vs.loading.close();
          console.error(err);
        });
    },
  },
  beforeRouteLeave: function (to, from, next) {
    if (setLiveVisitorWatch) {
      clearInterval(setLiveVisitorWatch);
    }
    next(true);
  },
  mounted() {
    $(document).ready(function () {
      $(document).mousemove(function (event) {
        counter = 0;
      });
    });
    vm = this;
    firstVisit = true;
    this.gridApi = this.gridOptions.api;
    this.filtrHours = 6;
    this.filtrDay = null;
    this.changeFilterByDays(6);
    setLiveVisitorWatch = setInterval(function () {
      counter += 10;
      if (counter == 300) {
        alert("Please click 'OK' to keep working");
      } else {
         vm.showUpdatedTxt = false;
        vm.changeFilterByDays(vm.filterModel);
      }
    }, 10000);
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }

    //this.getLiveVisitorsData();
  },
  created() {
    if (!moduleAnalytics.isRegistered) {
      this.$store.registerModule("analytics", moduleAnalytics);
      moduleAnalytics.isRegistered = true;
    }
    //vm = this;
    //debugger;
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })*/
    //if (!moduleAnalytics.isRegistered) {
    //  this.$store.registerModule("analytics", moduleAnalytics);
    //  moduleAnalytics.isRegistered = true;
    //}
    //this.$store.dispatch("analytics/fetchUserJourneyData").catch(err => {
    //  //console.error(err)
    //});
    //this.getLiveVisitorsData();
    /*let html = "Subject: BNI Cochin Welcomes You to Celebrate Regional Awards & Business Conclave 2020!";
    html += "\n\nHi @@attendee@@, \n\nYou are successfully registered to the Regional Awards & Business Conclave 2020 by BNI Cochin. \nBelow is the link and credentials to login:";
    html += "\n\nLogin URL: https://bni.e2m.live/  \n\nUsername: Registered Email Address \nPin: @@UserPin@@ ";
    html += "\n\nSee you at the Conclave!";
    html +="\n\nThank you,\nTeam e2m OnAir";
    html += "\n\nThis is an auto-generated e-mail. Please do not reply to this e-mail. For any queries or help, please e-mail to support@e2m.live";
    this.welcomeMailText = html;*/
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>